import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function TagSuggestionsData() {
    this.defaultAttrs({
        dataList: '[data-tag-editor-data]',
        dataListItem: '[data-tag-editor-data-item]',
        caseSensitive: null,
    });

    this.fetchSuggestions = function(query) {
        const suggestions = [];
        const self = this;
        this.select('dataListItem')
            .filter(function() {
                return self.filterFunction(this, query);
            })
            .each(function() {
                suggestions.push($(this).attr('data-tag-editor-data-item-value'));
            });
        this.processSuggestions(suggestions, query);
    };

    this.filterFunction = function(item, query) {
        let itemTitle = $(item).attr('data-tag-editor-data-item-display-title');
        let queryTitle = query;
        if (!this.attr.caseSensitive) {
            itemTitle = itemTitle.toLowerCase();
            queryTitle = queryTitle.toLowerCase();
        }
        return itemTitle.indexOf(queryTitle) > -1;
    };

    this.getData = function(event, data) {
        const query = data.userString;
        if (query && query.trim()) {
            this.fetchSuggestions(query);
        } else {
            this.processSuggestions([], '');
        }
    };

    this.processSuggestions = function(suggestions, userString) {
        this.trigger('dataSuggestionsDataServed', {
            userString,
            suggestions,
        });
    };

    this.after('initialize', function() {
        this.on('dataSuggestionsDataRequested', this.getData);
    });
}

export default defineComponent(TagSuggestionsData);



// WEBPACK FOOTER //
// ./src/js/component_data/local-tag-suggestions.js